<template>
    <div class="Maintenance">
        <div class="tabs-container">
            <div
                :class="['tab-item', tab.name === $route.meta.name ? 'active' : '']"
                v-for="tab in tabs"
                :key="tab.name"
                @click="() => $router.replace({name:tab.path})"
            >
                <span>{{ tab.name }}</span>
            </div>
        </div>
        <keep-alive>
            <router-view />
        </keep-alive>
    </div>
</template>
<script>
    export default {
        name: "Maintenance",
        data() {
            return {
                tabs: [
                    {
                        name: '标准保养计划',
                        path: 'StandardPlan'
                    },
                    {
                        name: '油液及润滑脂',
                        path: 'OilAndGrease'
                    }
                    // ,
                    // {
                    //     name: '积分规则',
                    //     path: 'IntegrationRule'
                    // }
                ]
            }
        }
        
    }
</script>
<style scoped lang="less">
    .Maintenance {
        height: 100%;
        display: flex;
        flex-direction: column;
        // font-family: -apple-system,BlinkMacSystemFont,'Helvetica Neue',Helvetica,Segoe UI,Arial,Roboto,'PingFang SC',miui,'Hiragino Sans GB','Microsoft Yahei',sans-serif;
    }
    .tabs-container {
        display: flex;
        border-bottom: 2px solid #dfdfdf;
        .tab-item {
            flex: 1;
            text-align: center;
            span {
                position: relative;
                display: inline-block;
                font-size: 14px;
                line-height: 40px;
                &::after {
                    transition: all 0.2s;
                    content: '';
                    position: absolute;
                    top: 100%;
                    left: 0;
                    width: 100%;
                    height: 2px;
                    background-color: #b6862d;
                    transform-origin: center;
                    transform: scale(0);
                }
            }
            &.active span::after {
                transform: scale(1);
            }
        }
    }
</style>
